<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <Filter></Filter>
    <List></List>
  </div>
  <ActivityModal></ActivityModal>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import Filter from './components/Filter.vue'
import ActivityModal from './components/ActivityModal.vue'
import {
  queryPageActivities,
  savePageActivities,
  updatePageActivities
} from '../../server/modules/orderRewards'
import { toRefs, reactive, provide, onMounted, nextTick, computed } from 'vue'
import useAPI from 'UseApi'
const { common_querySiteInfo_get_, common_lang_get_ } = useAPI(null, [
  3426,
  4240,
  5922,
  5390,
  7056
])
import dayjs from 'dayjs'
import { message } from 'ant-design-vue'
export default {
  components: {
    FourElement,
    Filter,
    List,
    ActivityModal
  },
  setup() {
    const state = reactive({
      brands: [],
      channels: [],
      sites: [],
      langCode: null,
      langDic: [],
      searchParams: {
        siteId: 1,
        channelId: 1,
        brandId: 1,
        terminalId: 1
      },
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //表格数据
      dataSource: [],
      //列
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '规则名称',
          dataIndex: 'activityName',
          key: 'activityName',
          align: 'center'
        },
        {
          title: '活动时间',
          align: 'center',
          dataIndex: 'time'
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          key: 'createBy',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      //筛选
      filterData: {
        activityName: '',
        status: ''
      },
      //
      initList: () => {
        state.getTabList()
      },
      //重置筛选
      resetFilter: () => {
        state.filterData = {
          activityName: '',
          status: ''
        }
        state.initList()
      },
      //
      getSearchList: () => {
        common_querySiteInfo_get_({
          state
        })
      },
      //table数据
      getTabList: () => {
        const param = {
          item: { ...state.searchParams, ...state.filterData },
          ...state.pagination,
          size: state.pagination.pageSize
        }
        queryPageActivities(param)
          .then(e => {
            if (e.success) {
              state.dataSource = e.data.records
              state.pagination.total = e.data.total
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      modalVisible: false,
      //添加参数
      activityParams: {
        activityName: '',
        endTime: '',
        startTime: '',
        // mainTitle: '',
        // subTitle: '',
        // buttonName: '',
        langs: [],
        icon: '',
        orderCount: '',
        discountRuleId: '',
        validDays: '',
        status: 1,
        timeSet: []
      },
      conditionsList: [
        {
          label: '条件名称',
          value: '下单数'
        },
        {
          label: '操作符',
          value: '等于'
        },
        {
          label: '条件值',
          value: ''
        },
        {
          label: '关联券规则',
          value: ''
        },
        {
          label: '券有效日期',
          value: ''
        }
      ],
      //校验
      activityRules: {
        activityName: [
          { required: true, message: '请输入活动名称！' },
          { max: 50, message: '长度不能超过50!' }
        ],
        timeSet: [{ required: true, message: '请输入活动时间！' }],
        // mainTitle: [
        //   { required: true, message: '请输入主标题！' },
        //   { message: '长度不能超过50!', max: 50 }
        // ],
        // subTitle: [
        //   { required: true, message: '请输入副标题！' },
        //   { message: '长度不能超过50!', max: 50 }
        // ],
        // buttonName: [
        //   { required: true, message: '请输入按钮名称！' },
        //   { message: '长度不能超过50!', max: 50 }
        // ],
        icon: [{ required: true, message: '请上传图片！' }]
      },
      //0新增 1编辑 2详情
      modalType: 0,
      //添加
      addActive: async (type, info) => {
        await common_lang_get_(state.searchParams, state)
        state.resetActivityParams()
        if (info) {
          state.activityParams = {
            ...info,
            discountRuleId: info.discountRuleId.toString(),
            orderCount: info.orderCount.toString(),
            validDays: info.validDays.toString(),
            timeSet: [dayjs(info.startTime), dayjs(info.endTime)]
          }
        }
        state.modalType = type
        state.modalVisible = true
        nextTick(() => {
          state.activityRef.clearValidate()
        })
      },
      //重置数据
      resetActivityParams: () => {
        const langs = state.langDic.map(item => ({
          langCode: item.value,
          mainTitle: '',
          subTitle: '',
          buttonName: ''
        }))
        state.activityParams = {
          activityName: '',
          endTime: '',
          startTime: '',
          langs,
          mainTitle: '',
          subTitle: '',
          buttonName: '',
          icon: '',
          orderCount: '',
          discountRuleId: '',
          validDays: '',
          status: 1,
          timeSet: []
        }
      },
      activityRef: null,
      isEditDisabled: computed(() => {
        return (
          (state.modalType === 1 &&
            state.defaultLanguageCode !== state.langCode) ||
          state.modalType === 2
        )
      }),
      modalCancel: () => {
        state.modalVisible = false
      },
      //
      modalSubmit: async () => {
        if (state.modalType !== 2) {
          let isMainTitleEmpty = false
          let issubTitleEmpty = false
          let isButttonNameEmpty = false
          state.activityParams.langs.forEach(item => {
            if (!item.mainTitle) {
              isMainTitleEmpty = true
            }
            if (!item.subTitle) {
              issubTitleEmpty = true
            }
            if (!item.buttonName) {
              isButttonNameEmpty = true
            }
          })
          if (isMainTitleEmpty || issubTitleEmpty || isButttonNameEmpty) {
            message.error('请完成多语言下的标题、副标题、Button文案信息')
            return
          }
          state.activityRef
            .validateFields()
            .then(() => {
              const param = {
                ...state.activityParams,
                ...state.searchParams,
                createTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
              }
              savePageActivities(param)
                .then(e => {
                  if (e.success) {
                    state.modalVisible = false
                    state.getTabList()
                  } else {
                    message.warning(e.retInfo)
                  }
                })
                .catch(e => {
                  console.log('e: ', e)
                  message.warning(e.retInfo)
                })
            })
            .catch(e => {
              console.log('e: ', e)
            })
        } else {
          state.modalVisible = false
        }
      },
      //时间
      timeChange: e => {
        state.activityParams.startTime =
          e === null || e.length === 0
            ? null
            : e[0].format('YYYY-MM-DD HH:mm:ss')
        state.activityParams.endTime =
          e === null || e.length === 0
            ? null
            : e[1].format('YYYY-MM-DD HH:mm:ss')
      },
      //img
      imageType: {
        type: 'pc',
        tip: 'PC端(三倍图) 360 * 360',
        width: 360,
        height: 360,
        size: 500
      },
      //获取图片地址
      setImgUrl: url => {
        state.activityParams.icon = url
        state.activityRef.clearValidate(['icon'])
      },
      //删除图片
      delActivityImg: () => {
        state.activityParams.icon = ''
      },
      //校验
      formRules: (r, v) => {
        if (!v) {
          return Promise.reject(new Error('不能为空'))
        } else {
          return Promise.resolve()
        }
      },
      //更新状态
      updateStatus: info => {
        const param = {
          id: info.id,
          status: info.status === 2 ? 1 : 2
        }
        updatePageActivities(param)
          .then(e => {
            if (e.success) {
              state.getTabList()
            } else {
              message.warning(e.retInfo)
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      }
    })
    onMounted(() => {
      state.getSearchList()
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
